
import { Base } from '../base-component';
import './calculator-item.component.scss';

export class CalculatorItem extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/calculator-item/calculator-item.component.ts